import axios from '@/services/api';

export const getUsers = async ({ commit }, params) => {

    const response = await axios.get('/users', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setUsers', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getTotals= async ({ commit }, params) => {

    const response = await axios.get('/totals', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setTotals', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getUser = async ({ commit }, id) => {
    await axios.get(`/users/${id}`).then(response => {
        const { data } = response;
        if (data) {
            commit('setUser', data);

        }
    })
}

export const getCurrentUser = async ({ commit }, id) => {
    commit('setCurrentUser', null)
    await axios.get(`/users/${id}`).then(response => {
        const { data } = response;
        if (data) {
            commit('setCurrentUser', data);
        }
    })
}

export const add = async (_, payload) => {
    return await axios.post("users", payload);
};

export const edit = async (_, payload) => {
    return await axios.put("users/" + payload['id'], payload);
};

export const changePassword = async ({ commit }, payload) => {

    commit('setErrorMessage', null)

    await axios.put("users/reset-password/" + payload.id + (payload.byAdmin ? "?byAmin=true" : ''), payload
    ).then(response => {
        if (response.data.message) {
            commit('setErrorMessage', response.data.message);
        }
        commit('setLoading', false);
    }).catch(error => {
        console.log(error);
        commit('setLoading', false);
    });

};

export const recuperatePassword = async ({ commit }, payload) => {

    commit('setErrorMessage', null)

    return await fetch(process.env.VUE_APP_URL + "/confirm/recuperate-password/" + payload.token , {
        method: 'POST',
        body: JSON.stringify({
            password: payload.password,
            repeatedPassword: payload.repeatedPassword
        })

    });

};

export const deleteUser = async ({ commit }, id) => {

    await axios.delete(`/users/${id}`).then(()=>{
        commit('setLoading', false);
    })
};

export const forgotPassword = async (_, email) => {

    return await fetch(process.env.VUE_APP_URL+"/forgot-password/"+email , {
        method: 'GET'
    });
}